import { cartResponseSchema } from "@/networking/carts.types";
import { fetchApi } from "@/lib/api-helpers";
import { z } from "zod";

export {
  shippingOptionSchema,
  type ShippingMethod,
} from "@/networking/shipping.types";

const shippingMethodInputSchema = z.object({
  shipping_method_id: z.string(),
});

export async function updateShippingMethod({
  cartToken,
  shippingMethodId,
}: {
  cartToken: string;
  shippingMethodId: string;
}) {
  return fetchApi({
    endpoint: `/carts/${cartToken}/shipping_method`,
    method: "POST",
    input: { shipping_method_id: shippingMethodId },
    inputSchema: shippingMethodInputSchema,
    outputSchema: cartResponseSchema,
  });
}
